export const lookupConfig = {
  headings: [
    {
      headingLabel: "Inactive",
      icon: "",
      width: "10%",
      inputType: "checkbox",
    },
    {
      headingLabel: "Description",
      icon: "",
      inputType: "text",
      width: "80%",
    },
  ],
  dataNodes: ["is_active", "lookup_value"],
  primaryKey: "lookup_data_id",
  actions: ["pen", "times"],
  nodeFields: [
    {
      column: "is_active",
      icon: "check",
    },
  ],
  buttonFields: [
    {
      column: "",
      icon: "pen",
    },
  ],
  inlineEdits: [
    {
      dataNode: "is_active",
      width: "9%",
    },
    {
      dataNode: "lookup_value",
      width: "65%",
      isMandatory: true,
    },
  ],
};
